export default "__VITE_ASSET__CVm03xQX__"